import React from "react";
import KioskStartButton from "../components/start-button";

export default function TNCS({ navigate, setInputWeight }) {
  return (
    <div className="flex flex-col items-center justify-between w-full h-full relative">
      <div>
        <p className="text-[80px] text-white text-center mt-[90px]">
          Quick question...
        </p>
        <p className="text-white text-[60px] font-[400]">
          Have you accepted the terms and
          <br /> conditions since arriving in store?
        </p>
      </div>

      <div className="grid grid-cols-2 gap-[36px] px-[3vh] relative z-10 mb-[3vh]">
        <KioskStartButton
          onClick={() => {
            setInputWeight(0);
            navigate("holding");
          }}
          icon="close"
        >
          No, Exit
        </KioskStartButton>

        <KioskStartButton
          className="font-semibold"
          onClick={() => {
            navigate("placePackage");
          }}
          icon="check"
          iconColor="black"
          color="yellow"
        >
          Yes, Continue
        </KioskStartButton>
      </div>
    </div>
  );
}
